var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMdiTimerSand = function SvgMdiTimerSand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M6 2h12v6l-4 4 4 4v6H6v-6l4-4-4-4zm10 14.5-4-4-4 4V20h8zm-4-5 4-4V4H8v3.5zM10 6h4v.75l-2 2-2-2z"
  })));
};
export { SvgMdiTimerSand as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMkgxOFY4TDE0IDEyTDE4IDE2VjIySDZWMTZMMTAgMTJMNiA4VjJaTTE2IDE2LjVMMTIgMTIuNUw4IDE2LjVWMjBIMTZWMTYuNVpNMTIgMTEuNUwxNiA3LjVWNEg4VjcuNUwxMiAxMS41Wk0xMCA2SDE0VjYuNzVMMTIgOC43NUwxMCA2Ljc1VjZaIiBmaWxsPSIjRkVGRUZFIi8+Cjwvc3ZnPgo=";